import React, { useContext } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import style from './SearchField.module.scss';

export const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IDishAssignmentContext>(DishAssignmentContext);

	return (
		<div className={style.container}>
			<SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />
		</div>
	);
};
